export default __webpack_public_path__ + "static/media/deepdao_header_logo.ed41058a.svg";